<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input
                v-model="queryParam.keywords"
                allowClear
                placeholder="搜索关键字"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="赛季">
              <a-select
                v-model="queryParam.saiji"
                placeholder="请选择"
                allowClear
              >
                <a-select-option
                  v-for="(option, index) in saijiOptions"
                  :value="option.id"
                  >{{ option.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col> 
 
          <a-col :md="(!advanced && 6) || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="
                (advanced && { float: 'right', overflow: 'hidden' }) || {}
              "
            >
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button
                style="margin-left: 8px"
                @click="() => (queryParam = {})"
                >重置</a-button
              >
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? "收起" : "展开" }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
      
    </div>

    <div class="table-operator">  

      <a-button @click="onSetting" style="margin-left: 8px">
        设置 <a-icon type="setting" />
      </a-button>
 

    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{
        show: true,
        clear: () => {
          this.selectedRowKeys = [];
        },
      }"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
    >
      <span slot="name" slot-scope="text, record">
        <div style="margin-left: 10px; float: left">
          {{ record.name }}
          <br /><span style="color: #999"
            >{{ record.province }}{{ record.city }}{{ record.county }}</span
          >
          <br />
          举办时间 {{ record.saidate | timeFormat }} 
        </div>
      </span>
      <span slot="status" slot-scope="text, record">
        俱乐部申报 
        <a-tag color="green" v-if="record.club_saiqu.club_is_open==1">开启</a-tag>
        <a-tag v-else>关闭</a-tag>
        <br />
        俱乐部申报开放时间:
        <span v-if="record.club_saiqu.club_start_time>0&&record.club_saiqu.club_end_time>0"><br/>{{ record.club_saiqu.club_start_time | timeFormat }} 至{{ record.club_saiqu.club_end_time | timeFormat }}</span> 
        <span v-else>不限</span>
        <!-- 俱乐部建设申报 
        <a-tag color="green" v-if="record.club_saiqu.club_jianshe_is_open==1">开启</a-tag>
        <a-tag v-else>关闭</a-tag>
        <br />
        俱乐部建设申报开放时间:
        <span v-if="record.club_saiqu.club_start_time>0&&record.club_saiqu.club_jianshe_end_time>0"><br/>{{ record.club_saiqu.club_jianshe_start_time | timeFormat }} 至{{ record.club_saiqu.club_jianshe_end_time | timeFormat }}</span> 
        <span v-else>不限</span> -->
        <br />
        四好申报
        <a-tag color="green" v-if="record.club_saiqu.sihao_is_open==1">开启</a-tag>
        <a-tag v-else>关闭</a-tag>
        <br />
        四好申报开放时间:
        <span v-if="record.club_saiqu.sihao_start_time>0&&record.club_saiqu.sihao_end_time>0"><br/>{{ record.club_saiqu.sihao_start_time | timeFormat }} 至{{ record.club_saiqu.sihao_end_time | timeFormat }}</span> 
        <span v-else>不限</span>
        <br /> 
        大课间申报
        <a-tag color="green" v-if="record.club_saiqu.dakejian_is_open==1">开启</a-tag>
        <a-tag v-else>关闭</a-tag>
        <br />
        大课间开放时间:
        <span v-if="record.club_saiqu.dakejian_start_time>0&&record.club_saiqu.dakejian_end_time>0"><br/>{{ record.club_saiqu.dakejian_start_time | timeFormat }} 至{{ record.club_saiqu.dakejian_end_time | timeFormat }}</span> 
        <span v-else>不限</span>
        <br /> 
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleEdit(record)">设置</a> 

        </template>
      </span>
    </s-table>
 

    <a-modal
      :maskClosable="false"
      title="操作"
      :width="1200"
      :bodyStyle="{ maxHeight: '500px', overflowY: 'scroll' }"
      v-model="visible"
      @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form"> 

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="俱乐部申报"
                hasFeedback
              >
                <r-switch
                  :formData="formData"
                  field="club_is_open"
                  :checkedValue="1"
                  :unCheckedValue="2"
                  checkedChildren="开启"
                  unCheckedChildren="关闭"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="俱乐部申报时间"
                hasFeedback
              >
                <a-range-picker
                  v-model="formData.club_range_moment"
                  :showTime="{
                    defaultValue: [
                      moment('00:00:00', 'HH:mm:ss'),
                      moment('23:59:59', 'HH:mm:ss'),
                    ],
                  }"
                  format="YYYY-MM-DD HH:mm:ss"
                />
              </a-form-item>
            </a-col>  
          </a-row>
<!-- 

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="俱乐部建设申报"
                hasFeedback
              >
                <r-switch
                  :formData="formData"
                  field="club_jianshe_is_open"
                  :checkedValue="1"
                  :unCheckedValue="2"
                  checkedChildren="开启"
                  unCheckedChildren="关闭"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="俱乐部建设申报时间"
                hasFeedback
              >
                <a-range-picker
                  v-model="formData.club_jianshe_range_moment"
                  :showTime="{
                    defaultValue: [
                      moment('00:00:00', 'HH:mm:ss'),
                      moment('23:59:59', 'HH:mm:ss'),
                    ],
                  }"
                  format="YYYY-MM-DD HH:mm:ss"
                />
              </a-form-item>
            </a-col>  
          </a-row> -->

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="四好申报"
                hasFeedback
              >
                <r-switch
                  :formData="formData"
                  field="sihao_is_open"
                  :checkedValue="1"
                  :unCheckedValue="2"
                  checkedChildren="开启"
                  unCheckedChildren="关闭"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="四好申报时间"
                hasFeedback
              >
                <a-range-picker
                  v-model="formData.sihao_range_moment"
                  :showTime="{
                    defaultValue: [
                      moment('00:00:00', 'HH:mm:ss'),
                      moment('23:59:59', 'HH:mm:ss'),
                    ],
                  }"
                  format="YYYY-MM-DD HH:mm:ss"
                />
              </a-form-item>
            </a-col>
          </a-row>
 


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="大课间申报"
                hasFeedback
              >
                <r-switch
                  :formData="formData"
                  field="dakejian_is_open"
                  :checkedValue="1"
                  :unCheckedValue="2"
                  checkedChildren="开启"
                  unCheckedChildren="关闭"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="大课间申报时间"
                hasFeedback
              >
                <a-range-picker
                  v-model="formData.dakejian_range_moment"
                  :showTime="{
                    defaultValue: [
                      moment('00:00:00', 'HH:mm:ss'),
                      moment('23:59:59', 'HH:mm:ss'),
                    ],
                  }"
                  format="YYYY-MM-DD HH:mm:ss"
                />
              </a-form-item>
            </a-col>
          </a-row>
 
 
        </a-form>
      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button
          key="forward"
          :loading="saveLoading"
          type="primary"
          @click="handleOk"
          >保存</a-button
        >
      </template>
    </a-modal>


    <a-modal
        :maskClosable="false"
            title="设置"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="settingVisible"
            @ok="handleSettingOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form3" >

          <a-row :gutter="48">
            <a-col :md="12" :sm="24"> 
              <a-form-item 
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                label="俱乐部申报" 
              >
                <r-switch 
                  :formData="settingFormData"
                  field="club_is_open"
                  :checkedValue="1"
                  :unCheckedValue="2"
                  checkedChildren="开启"
                  unCheckedChildren="关闭"
                />
              </a-form-item> 
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="申报关闭理由"
                      extra=""
                      hasFeedback
              >
                <a-input v-model="settingFormData.club_is_open_desc" />
              </a-form-item>
            </a-col>
          </a-row> 


          <a-row :gutter="48">
            <a-col :md="12" :sm="24"> 
              <a-form-item 
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                label="俱乐部建设申报" 
              >
                <r-switch 
                  :formData="settingFormData"
                  field="club_jianshe_is_open"
                  :checkedValue="1"
                  :unCheckedValue="2"
                  checkedChildren="开启"
                  unCheckedChildren="关闭"
                />
              </a-form-item> 
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="申报关闭理由"
                      extra=""
                      hasFeedback
              >
                <a-input v-model="settingFormData.club_jianshe_is_open_desc" />
              </a-form-item>
            </a-col>
          </a-row> 


          <a-row :gutter="48">
            <a-col :md="12" :sm="24"> 
              <a-form-item 
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                label="四好申报" 
              >
                <r-switch 
                  :formData="settingFormData"
                  field="sihao_is_open"
                  :checkedValue="1"
                  :unCheckedValue="2"
                  checkedChildren="开启"
                  unCheckedChildren="关闭"
                />
              </a-form-item> 
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="申报关闭理由"
                      extra=""
                      hasFeedback
              >
                <a-input v-model="settingFormData.sihao_is_open_desc" />
              </a-form-item>
            </a-col>
          </a-row> 

          <a-row :gutter="48">
            <a-col :md="12" :sm="24"> 
              <a-form-item 
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                label="大课间申报" 
              >
                <r-switch 
                  :formData="settingFormData"
                  field="dakejian_is_open"
                  :checkedValue="1"
                  :unCheckedValue="2"
                  checkedChildren="开启"
                  unCheckedChildren="关闭"
                />
              </a-form-item> 
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="申报关闭理由"
                      extra=""
                      hasFeedback
              >
                <a-input v-model="settingFormData.dakejian_is_open_desc" />
              </a-form-item>
            </a-col>
          </a-row> 


        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="settingVisible=false">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleSettingOk">保存</a-button>
      </template>
    </a-modal>

   
  </a-card>
</template>

<script>
  import setting from '@/config/setting'
import STable from "@/components/table/";
import ATextarea from "ant-design-vue/es/input/TextArea";
import AInput from "ant-design-vue/es/input/Input";
import EditableCell from "@/components/EditableCell/";
import PicUploader from "@/components/PicUploader/";
import FileUploader from "@/components/FileUploader/";
import VideoUploader from "@/components/VideoUploader/";
import RSwitch from "@/components/RSwitch/";
import ContentPicker from "@/components/ContentPicker/";
import areaOptions from "@/utils/area";
import UserPicker from "@/components/UserPicker/";
import moment from "moment";
import "moment/locale/zh-cn";

moment.locale("zh-cn");

import {
  getClubSaiquList,  
  getSaijiList, 
  getClubSaiquDetail,
  clubSaiquEdit,
  getClubSaiquSetting,
  setClubSaiquSetting,
} from "@/api/sai"; 

export default {
  name: "KaojiSaiquList",
  components: {
    AInput,
    ATextarea,
    FileUploader,
    PicUploader,
    STable,
    RSwitch,
    EditableCell,
    ContentPicker,
    UserPicker,
    VideoUploader,
  },
  data() {
    return {
      areaOptions,
      MiniCode: "",
      userListVisible:false,
      visible: false,
      applyVisible: false,
      documentVisible: false,
      saveLoading: false,
      subjectTypeOptions: [],
      mainUnitShow: false,
      holdUnitShow: false,
      helpUnitShow: false,
      unitName: "",
      form2: this.$form.createForm(this),
      holdUnitName: "",
      helpUnitName: "",
      time_range_moment:[], 
      saijiOptions: [],
      settingFormData:{

      },
      formData: {
        id: 0,
        saiqu:0,
        sihao_is_open: 1, 
        club_is_open: 1, 
        club_jianshe_is_open: 1, 
        dakejian_is_open: 1, 
        club_range_moment: [], 
        club_jianshe_range_moment: [], 
        sihao_range_moment: [], 
        dakejian_range_moment: [], 
      },
      labelCol: {
        //          xs: { span: 24 },
        //          sm: { span: 5 },
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      }, 
      mdl: {},
      form: this.$form.createForm(this),

      // 高级搜索 展开/关闭
      advanced: false,
      settingVisible:false,
      // 查询参数
      queryParam: {
        keywords: "",
      },
      // 表头
      columns: [
        {
          title: "#",
          dataIndex: "id",
          width: "50px",
        },
        {
          title: "名称",
          dataIndex: "name",
          scopedSlots: { customRender: "name" },
        },
        {
          title: "详情",
          dataIndex: "status",
          scopedSlots: { customRender: "status" },
        },
        {
          title: "操作",
          dataIndex: "action",
          fixed: "right",
          width: 200,
          scopedSlots: { customRender: "action" },
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        console.log("loadData");
        console.log(this.queryParam);
        let that = this;

        this.queryParam = Object.assign(this.queryParam, parameter);
        return getClubSaiquList(this.queryParam).then((res) => {
          console.log("res");
          return res.data;
        });
      },

      selectedRowKeys: [],
      selectedRows: [], 
 
 
    };
  },
  computed: {},
  created() {},

  mounted() {
    let that = this;
    that.getSaijiOptions();  
  },
  methods: {
    moment, 
    onSetting(){
      let self = this
      this.settingVisible = true
      getClubSaiquSetting( ).then(res => {
        self.settingFormData = res.data;
        // console.log(this.mdl)
      })
    },  
      handleSettingOk(e) {
        let self = this;
        e.preventDefault()
        this.form2.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            self.saveLoading = true;
            setClubSaiquSetting(self.settingFormData).then(res => {
              self.$message.success('修改成功')
              self.settingVisible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }
        })
      },


    handleCancel() {
      this.visible = false;
    },
    getSaijiOptions() {
      let that = this;
      getSaijiList().then((res) => {
        that.saijiOptions = res.data.list;
      });
    }, 
    //展开关闭
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },      

    handleEdit(record) {
      let self = this;
      this.visible = true;
      getClubSaiquDetail({ id: record.id }).then((res) => {
        setTimeout(() => {
          self.form.setFieldsValue({ ...res.data });
          self.formData.id = record.id;
          console.log("handleEdit");  
          res.data.club_range_moment =(res.data.club_start_time>0&&res.data.club_end_time>0)? [
            moment(res.data.club_start_time * 1000),
            moment(res.data.club_end_time * 1000),
          ]:[];
          res.data.club_jianshe_range_moment =(res.data.club_jianshe_start_time>0&&res.data.club_jianshe_end_time>0)? [
            moment(res.data.club_jianshe_start_time * 1000),
            moment(res.data.club_jianshe_end_time * 1000),
          ]:[];
          res.data.sihao_range_moment = (res.data.sihao_start_time>0&&res.data.sihao_end_time>0)? [
            moment(res.data.sihao_start_time * 1000),
            moment(res.data.sihao_end_time * 1000),
          ]:[];
          res.data.dakejian_range_moment = (res.data.dakejian_start_time>0&&res.data.dakejian_end_time>0)? [
            moment(res.data.dakejian_start_time * 1000),
            moment(res.data.dakejian_end_time * 1000),
          ]:[];
          self.formData = { ...res.data };
        }, 200);
      });
      // console.log(this.mdl)
    },
   

    // 增改 处理
    handleOk(e) {
      let self = this;
      e.preventDefault();
      if (self.formData.club_is_open==1 && self.formData.club_range_moment.length != 2) {
        self.$message.error("请选择俱乐部申报时间范围");
        return;
      } 
      if (self.formData.club_jianshe_is_open==1 && self.formData.club_jianshe_range_moment.length != 2) {
        // self.$message.error("请选择俱乐部建设申报时间范围");
        // return;
      } 
      if (self.formData.sihao_is_open==1 &&self.formData.sihao_range_moment.length != 2) {
        self.$message.error("请选择四好申报时间范围");
        return;
      }
      if (self.formData.dakejian_is_open==1 &&self.formData.dakejian_range_moment.length != 2) {
        self.$message.error("请选择大课间申报时间范围");
        return;
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          console.log("Received valuess of formData: ", self.formData);
          self.saveLoading = true; 
            clubSaiquEdit({
              id: self.formData.id,
              saiqu: self.formData.saiqu, 
              club_start_time:self.formData.club_range_moment.length>0?self.formData.club_range_moment[0].format("YYYY-MM-DD HH:mm:ss"):0,
              club_end_time:self.formData.club_range_moment.length>0?self.formData.club_range_moment[1].format("YYYY-MM-DD HH:mm:ss"):0,
              club_jianshe_start_time:self.formData.club_jianshe_range_moment.length>0?self.formData.club_jianshe_range_moment[0].format("YYYY-MM-DD HH:mm:ss"):0,
              club_jianshe_end_time:self.formData.club_jianshe_range_moment.length>0?self.formData.club_jianshe_range_moment[1].format("YYYY-MM-DD HH:mm:ss"):0,
              club_is_open: self.formData.club_is_open, 
              club_jianshe_is_open: self.formData.club_jianshe_is_open, 
              sihao_is_open: self.formData.sihao_is_open,  
              dakejian_is_open: self.formData.dakejian_is_open,  
              sihao_start_time:self.formData.sihao_range_moment.length>0?self.formData.sihao_range_moment[0].format("YYYY-MM-DD HH:mm:ss"):0,
              sihao_end_time:self.formData.sihao_range_moment.length>0?self.formData.sihao_range_moment[1].format("YYYY-MM-DD HH:mm:ss"):0,
              dakejian_start_time:self.formData.dakejian_range_moment.length>0?self.formData.dakejian_range_moment[0].format("YYYY-MM-DD HH:mm:ss"):0,
              dakejian_end_time:self.formData.dakejian_range_moment.length>0?self.formData.dakejian_range_moment[1].format("YYYY-MM-DD HH:mm:ss"):0,
            })
              .then((res) => {
                self.$message.success("配置成功");
                self.$refs.table.refresh(false);
                self.visible = false;
                self.saveLoading = false;
              })
              .catch((err) => {
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              }); 
        }
      });
    },

    onSearch() {
      let self = this;
      self.$refs.table.refresh(false);
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
  },
  filters: {},
  watch: {},
};
</script>
<style scoped>
.MiniCode{
  margin: 0 auto;
}
</style>
